var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33509 20.3657C4.34448 19.3536 3.59718 18.1293 3.1498 16.7856C2.70242 15.4419 2.5667 14.014 2.7529 12.6101C2.93911 11.2062 3.44236 9.86302 4.22455 8.6824C5.00673 7.50178 6.04733 6.51464 7.26753 5.79575C8.48773 5.07687 9.85552 4.64509 11.2673 4.53312C12.6791 4.42116 14.0979 4.63194 15.4161 5.1495C16.7344 5.66706 17.9176 6.47783 18.8761 7.5204C19.8346 8.56297 20.5432 9.80999 20.9484 11.167H23.3351C24.6224 11.1669 25.8757 11.5808 26.9097 12.3476C27.9438 13.1144 28.7038 14.1935 29.0774 15.4254C29.4511 16.6573 29.4187 17.9768 28.9849 19.1889C28.5511 20.4009 27.7389 21.4413 26.6684 22.1564",
    stroke: "#007CB0",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.5V28.5",
    stroke: "#007CB0",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3307 21.8333L15.9974 16.5L10.6641 21.8333",
    stroke: "#007CB0",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.0ae3826f80e7ef5ac71942113ddb18cd.svg";
export { ForwardRef as ReactComponent };